import { APP_ROUTES } from '@/constants/pages';
import { isServer } from '@/helpers';
import { useEffect, useRef } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import BookingFlowExtraTime from './extra-tid';
import BookingFlowAddOns from './tillval';
import BookingFlowSelectService from './valj-tjanst';
import BookingFlowSelectEmployee from './valj-utovare';

/**
 * Parent for the four /boka/:placeSlugId/* step routes — registered as ONE route (array path)
 * so it survives step transitions while the step pages mount and unmount. That is what lets
 * the R15 focus effect tell a step transition apart from entering the flow; a ref inside the
 * shell cannot, since the shell remounts on every navigation.
 */
const BookingFlowSteps = () => {
  const location = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // React Router keeps the document scroll on a push, so the flow would inherit the place
    // page's offset on entry.
    if (!isServer) window.scrollTo(0, 0);

    // R15: step transitions and guard redirects move focus to the new step's <h1> so screen
    // readers announce the swap; skipped on flow entry to not steal focus.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const heading = contentRef.current?.querySelector<HTMLElement>('h1');
    if (!heading) return;
    if (!heading.hasAttribute('tabindex')) {
      heading.setAttribute('tabindex', '-1');
    }
    heading.focus({ preventScroll: true });
  }, [location.pathname]);

  return (
    // display: contents — layout-neutral scope for the R15 heading lookup
    <div ref={contentRef} className="contents">
      <Switch>
        <Route exact path={APP_ROUTES.BOOKING_FLOW_SELECT_SERVICE} component={BookingFlowSelectService} />
        <Route exact path={APP_ROUTES.BOOKING_FLOW_SELECT_EMPLOYEE} component={BookingFlowSelectEmployee} />
        <Route exact path={APP_ROUTES.BOOKING_FLOW_ADD_ONS} component={BookingFlowAddOns} />
        <Route exact path={APP_ROUTES.BOOKING_FLOW_EXTRA_TIME} component={BookingFlowExtraTime} />
      </Switch>
    </div>
  );
};

export default BookingFlowSteps;
